import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { match, RouteComponentProps } from 'react-router-dom';

// Components
import App from '../../../components/app';
// Modules
import { CompanyById, TParams } from '../../../redux/reducers/api-types';
import { selectors as companySelectors } from '../../../redux/reducers/companies';
// Ressources
import { AccountRight, RightRank } from '../../../utils/userUtils';
import FidForm from '../../companies/fid/fid-form';

const B2C_KEY = 'b2c';
const B2C_RIGHT = AccountRight.REWARD_B2C;

interface FidB2CAddPageProps extends WithTranslation, RouteComponentProps {
    match: match<TParams>;
    companies: CompanyById;
}

interface FidB2CAddPageState {}

class FidB2CAddPage extends React.Component<FidB2CAddPageProps, FidB2CAddPageState> {
    constructor(props: FidB2CAddPageProps) {
        super(props);
        this.state = {};
    }

    render() {
        const { companies } = this.props;
        let companyB2C = { id: B2C_KEY, uuid: B2C_KEY };
        if (companies[B2C_KEY]) {
            companyB2C = Object.assign(companyB2C, companies[B2C_KEY]);
        }

        return (
            <App needRights={{ name: B2C_RIGHT, mode: RightRank.R }}>
                <FidForm company={companyB2C} rightCheck={B2C_RIGHT} />
            </App>
        );
    }
}

const FidB2CAddPageWithTranslation = withTranslation(['marketing', 'common'])(FidB2CAddPage);

const mapStateToProps = (state) => ({
    companies: companySelectors.getCompanies(state),
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(FidB2CAddPageWithTranslation);
